import { render, staticRenderFns } from "./fit-my-accessory.vue?vue&type=template&id=56d0f108"
import script from "./fit-my-accessory.vue?vue&type=script&lang=js"
export * from "./fit-my-accessory.vue?vue&type=script&lang=js"
import style0 from "./fit-my-accessory.vue?vue&type=style&index=0&id=56d0f108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports